import { GroupsReducer } from '../sanus/groups/state/groups.reducer';
import { GROUP_STATE_NAME } from '../sanus/groups/state/groups.selector';

export const AppReducer = {
	[GROUP_STATE_NAME]: GroupsReducer,
};
